import dateTimeFormatOptions from './dateTimeFormatOptions';

const formatDate = (timestamp) => {
  if (!timestamp) return '-';

  try {
    const date = new Date(timestamp);
    const formattedDate = new Intl.DateTimeFormat(navigator.language, dateTimeFormatOptions).format(date);
    return formattedDate;
  } catch (error) {
    console.error('Error formatting date:', error);
    return '-';
  }
};

export default formatDate;
